export default __webpack_public_path__ + "static/heatmaps1-13735daf536e85fd394b3dd123d51b92.png";